import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { StatusType, StatusTypeValue, StatusConfig, DEFAULT_STATUS_CONFIG } from "./types";

const STATUS_LABELS: Record<StatusTypeValue, string> = {
  OPENED: "Aberta",
  PENDING: "Aguardando",
  CLOSED: "Fechada",
  NOT_INTEGRATED: "Não Integrada",
};

interface StatusCellProps {
  status: StatusType;
  onClick?: () => void;
  statusConfig?: Partial<Record<StatusTypeValue, StatusConfig>>;
  dimmed?: boolean;
}

export function StatusCell({ status, onClick, statusConfig, dimmed }: StatusCellProps) {
  const config = status
    ? { ...DEFAULT_STATUS_CONFIG, ...statusConfig }[status]
    : null;

  if (!status || !config) {
    return (
      <Badge variant="outline" className={cn("text-xs", dimmed ? "opacity-10" : "opacity-50")}>
        -
      </Badge>
    );
  }

  const statusLabel = STATUS_LABELS[status] || status;
  const tooltipText = status === "NOT_INTEGRATED"
    ? "Loja não integrada neste dia"
    : `${statusLabel} - Clique para abrir a conciliação`;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold cursor-pointer hover:scale-110 hover:shadow-md active:scale-100 transition-all",
              dimmed && "opacity-10"
            )}
            style={{ backgroundColor: config.color, color: config.textColor === "text-white" ? "white" : "#422534" }}
            onClick={onClick}
          >
            {config.label}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
